<template>
  <painel-component>
    <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
      <h5 class="text-uppercase">Escolher peças do estoque</h5>
    </row-col-component>
    <error-component :errors="errors" v-if="showError"/>

    <div class="clearfix mb-2">
      <button-route class="float-end" :items="itemsOne"/>
    </div>

    <div class="alert alert-warning" role="alert" v-if="formData.baths.length === 0">
      Nenhuma peça disponível.
    </div>

    <template v-else v-for="(data, index) in formData.baths" :key="index">
      <div class="carousel__item"  :class="['carousel__item', activeItem[index] === true ? 'active' : '']" >
        <div   :class="['selectItem', activeItem[index] === true ? 'active' : '']"
             @click="enableInput(index)"></div>
        <input type="checkbox" v-model="baths" name="thumbs" :id="'thumbs' + index"
               :value="data.id">
        <label class="label-select position-relative" :for="'thumbs' + index">
          <div class="bg-body-secondary p-4">
            <div class="img-client">
              <img :src="data.photo" alt="">
            </div>

            <div>
              <row-component>
                <row-col-component
                    class-row-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <label>Grupo Banho:</label>
                  <input-component disabled v-model="data.group_name"/>
                </row-col-component>

                <row-col-component
                    class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                  <label>Quant, Estoque:</label>
                  <input-component type="number" disabled v-model="data.the_amount"/>
                </row-col-component>

                <row-col-component
                    class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                  <label>Peso unitário:</label>
                  <input-component disabled v-model="data.kilo"/>
                </row-col-component>

                <row-col-component
                    class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                  <label>Preço Bruto:</label>
                  <input-component disabled v-model="data.price_bruto"/>
                </row-col-component>
              </row-component>

              <row-component>
                <row-col-component
                    class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                  <label>Código:</label>
                  <input-component disabled v-model="data.code"/>
                </row-col-component>

                <row-col-component
                    class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Fornecedor:</label>
                  <input-component disabled v-model="data.provider_name" v-if="data.provider_id"/>
                  <input-component disabled v-model="data.origem" v-else/>
                </row-col-component>


                <row-col-component
                    class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                    v-if="formData.display_material== '2'">
                  <label>Tipo material:</label>
                  <input-component disabled v-model="data.part_material_name"/>
                </row-col-component>


                <row-col-component
                    class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                  <label>Quantidade:</label>
                  <input-component :id="'stock' + index" disabled type="number" v-model="data.stock"/>
                </row-col-component>

              </row-component>

              <RowComponent v-if="formData.stockPreference== '2'">
                <row-col-component
                    class-row-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                  <div>
                    <label>Comentário:</label>
                    <textarea class="form-control" :id="'comment' + index" rows="3" disabled
                              v-model="data.comment"></textarea>
                  </div>

                </row-col-component>

              </RowComponent>

              <RowComponent v-if="formData.stockPreference== '3'">


                <row-col-component class-row-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                  <label>Serviço:</label>
                  <Multiselect v-model="data.service_id" :options="multiselectService" :searchable="true"
                               :noOptionsText="noOptionsText" :noResultsText="noResultText" :id="'service_id' + index"
                               :disabled="serviceDisabled[index]"
                  />
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Base:</label>
                  <Multiselect v-model="data.base_id" :options="multiselectServiceBase" :searchable="true"
                               :noOptionsText="noOptionsText" :noResultsText="noResultText" :id="'base_id' + index"
                               :disabled="baseDisabled[index]"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Cor:</label>
                  <Multiselect v-model="data.cor_id" :options="multiselectServiceColor" :searchable="true"
                               :noOptionsText="noOptionsText" :noResultsText="noResultText" :id="'cor_id' + index"
                               :disabled="corDisabled[index]"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Verniz:</label>
                  <Multiselect v-model="data.verniz_id" :options="multiselectServiceVarnish" :searchable="true"
                               :noOptionsText="noOptionsText" :noResultsText="noResultText" :id="'verniz_id' + index"
                               :disabled="vernizDisabled[index]"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>{{formData.layerOrMilsession}}:</label>
                <input-component  maxlength="4"  v-money="money3" v-model="data.layer" :type="'text'"
                                  :disabled="layerDisabled[index]" :id="'layer' + index"
                />
                </row-col-component>


              </RowComponent>

              <RowComponent  v-if="formData.stockPreference== '4'">
                <row-col-component
                    class-row-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label for="">Botão:</label><br>

                  <div class="radio-btn-group">

                    <div v-for="(dataButton,indexButton) in formData.buttons" :key="indexButton">
                    <input type="radio"        :id="'option-' + index + '-' + indexButton"
                           :name="'options-' + index" class="radio-btn"
                           :value="dataButton.value" :disabled="buttonDisabled[index]" v-model="data.button_id" >
                    <label       :for="'option-' + index + '-' + indexButton"
                                 class="radio-label">{{dataButton.label}}</label>
                  </div>


                  </div>



                </row-col-component>
              </RowComponent>


            </div>
          </div>

          <span :id="'badge' + index" style="display:none;"
                class="position-absolute bottom-0 end-0 badge text-bg-secondary rounded-0">
                            Selecionado
                        </span>
        </label>
      </div>
    </template>

    <div v-if="formData.baths.length > 0">
      <button-submit :disables="sendForm" @click="submit" icon="fa-solid fa-plus" name="Adicionar"/>
    </div>
  </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/rows/RowComponent";
import RowColComponent from "@/components/rows/RowColComponent";
import InputComponent from "@/components/forms/InputComponent";
import ButtonSubmit from "@/components/buttons/ButtonSubmit";
import ErrorComponent from "@/components/alerts/ErrorComponent";

import {useToast} from "vue-toastification";
import ButtonRoute from "@/components/buttons/ButtonRoute.vue";
import Multiselect from "@vueform/multiselect";
import {VMoney} from "v-money";
import {MONEY} from "@/configs/constants";

const toast = useToast()
export default {
  name: "BathRequestCreate",
  components: {
    ButtonRoute,
    ErrorComponent,
    ButtonSubmit,
    InputComponent,
    RowColComponent,
    RowComponent,
    PainelComponent,
    Multiselect,
  },

  props: {
    hash: {
      required: true
    },

    id: {
      required: true
    }
  },

  directives: {
    money: VMoney
  },

  created() {
    this.loadItems()
  },

  data() {
    return {
      itemsOne: {
        route: `/hash/${this.hash}/${this.id}/stock-client-orders`,
        btn: 'btn-primary',
        icon: 'fa-rotate-left',
      },

      formData: {
        id: "",
        client_id: "",
        location_id: "",
        code: "",
        code_url: "",
        idOS: "",
        title: "",
        part_material_name: "",
        display_material: "",
        stockPreference: "",
        layerOrMilsession: "",
        baths: [],
        buttons: []
      },

      baths: [],
      errors: [],
      sendForm: false,
      showError: false,
      activeItem: [],
      serviceDisabled: [],
      baseDisabled: [],
      corDisabled: [],
      vernizDisabled: [],
      layerDisabled: [],
      buttonDisabled: [],

      money: MONEY,
      money3: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 1,
        allowBlank: false,
        max: 99,
        minimumNumberOfCharacters: 3,
        masked: true
      },

    }
  },

  methods: {
    loadItems() {
      this.$store.dispatch("loadStockClientOrderAdd", this.hash)
          .then((response) => {
            this.formData = response
            this.addProp(response.baths)

            this.activeItem = response.baths.map(() => false);
            this.serviceDisabled = response.baths.map(() => true);
            this.baseDisabled = response.baths.map(() => true);
            this.corDisabled = response.baths.map(() => true);
            this.vernizDisabled = response.baths.map(() => true);
            this.layerDisabled = response.baths.map(() => true);
            this.buttonDisabled = response.baths.map(() => true);

          }).catch(() => {
        toast.error('Erro desconhecido!', {timeout: 1500})
      })


      this.$store.commit("STORAGE", this.id)
      this.$store.dispatch('loadMultiselectService', this.hash)
      this.$store.dispatch('loadMultiselectServiceBase', this.hash)
      this.$store.dispatch('loadMultiselectServiceColor', this.hash)
      this.$store.dispatch('loadMultiselectServiceVarnish', this.hash)




    },

    addProp(data) {
      data.forEach((_element) => {
        _element.stock = _element.the_amount;
        _element.comment = null;
        _element.service_id = null; // adiciona valor para cada bath
        _element.base_id = null;
        _element.cor_id = null;
        _element.verniz_id = null;
        _element.layer = null;
        _element.button_id = null;

      })
    },

    enableInput(index) {
      let field = document.querySelector("#stock" + index)
      document.querySelector("#badge" + index).style.display = "block"
      field.disabled = field.disabled !== true;
      this.activeItem[index] = !this.activeItem[index];

      if (this.formData.stockPreference == '2') {
        let comment = document.querySelector("#comment" + index)
        comment.disabled = comment.disabled !== true;
      }

      if (this.formData.stockPreference == '3') {
        this.serviceDisabled[index] = !this.serviceDisabled[index];
        this.baseDisabled[index] = !this.baseDisabled[index];
        this.corDisabled[index] = !this.corDisabled[index];
        this.vernizDisabled[index] = !this.vernizDisabled[index];
        this.layerDisabled[index] = !this.layerDisabled[index];
      }


      if (this.formData.stockPreference == '4')
        this.buttonDisabled[index] = !this.buttonDisabled[index];



      if (field.disabled !== false) {
        // this.addProp(this.formData.baths)
        document.querySelector("#badge" + index).style.display = "none"
      }
    },

    submit() {
      let formDataPost = {hash: this.hash, baths: []}
      this.formData.baths.forEach((el,index) => {
        if(this.activeItem[index] === true){
          formDataPost.baths.push({
            id: el.id,
            bath_group_id: el.bath_group_id,
            the_amount: el.stock,
            kilo: el.kilo,
            photo: el.photo,
            origem: el.origem,
            code: el.code,
            price_bruto: el.price_bruto,
            peso_total: el.peso_total,
            group_name: el.group_name,
            comment: el.comment ?? '',
            service_id: el.service_id ?? '',
            base_id: el.base_id ?? '' ,
            cor_id: el.cor_id ?? '',
            verniz_id: el.verniz_id ?? '',
            layer: el.layer ?? '',
            button_id: el.button_id ?? '',
          })
        }

      })

      this.$store.dispatch("storeStockClientOrderAdd", formDataPost)
          .then(() => {
            toast.success("Pedido realizado com sucesso", {timeout: 1500})
            this.$router.push({name: "stock-client-orders", params: {hash: this.hash, id: this.id}})
          }).catch((e) => {
        this.showError = true
        this.sendForm = false
        this.errors = e.response.data.errors
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      })


    },


  },

  computed: {

    noOptionsText() {
      return this.$store.state.var.noOptionsText
    },

    noResultText() {
      return this.$store.state.var.noResultText
    },

    multiselectService() {
      return this.$store.state.var.multiselectService
    },

    multiselectServiceBase() {
      return this.$store.state.var.multiselectServiceBase
    },

    multiselectServiceColor() {
      return this.$store.state.var.multiselectServiceColor
    },

    multiselectServiceVarnish() {
      return this.$store.state.var.multiselectServiceVarnish
    },

  }

}
</script>

<style scoped>
.img-client {
  width: 150px;
  height: 200px;
  display: block;
  margin-right: 1rem;
}

.img-client img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel__item {
  position: relative;
  margin-bottom: 2rem;
}

input[type="checkbox"][id^="thumbs"] {
  display: none;
}

.carousel__item > .label-select {
  width: 100%;

}

.carousel__item > .label-select > div {
  display: flex;
}

.selectItem:before {
  content: " ";
  top: 10px;
  z-index: 1;
  right: 10px;
  width: 25px;
  height: 25px;
  color: white;
  display: block;
  line-height: 22px;
  border-radius: 50%;
  position: absolute;
  text-align: center;
  transform: scale(0);
  background-color: white;
  transition-duration: 0.4s;
  cursor: pointer;
}

.selectItem:before {
  content: "✓";
  transform: scale(1);
  background-color: var(--primary-color-hexa);
}

.selectItem:before {
  content: "✓";
  transform: scale(1);
  border-color: #b9b9b9;
  background-color: #b9b9b9;
}

.selectItem.active::before {
  background-color: var(--primary-color-hexa);
}

.carousel__item.active{
  border: 2px solid var(--primary-color-hexa);
}

.carousel__item input[type="checkbox"] + .label-select::after {
  display: none;
}


@media (max-width: 991px) {

  .carousel__item > .label-select {
    height: auto;
  }

  .carousel__item > .label-select > div {
    display: flex;
    flex-direction: column;
  }

  .img-client {
    margin: 1rem auto;
  }
}
</style>